import { produce } from "immer";
import * as Actions from "../actions/authActions";
import storage from "@storage";

const initialState = {
  isLoading: false,
  accounts: storage.get("accounts") || {},
  isPasswordRenewRequired:
    storage.get("isPasswordRenewRequired") === true ? true : false,
  isLimited: storage.get("isLimited") === true ? true : false,
  isNoMailbox: storage.get("isNoMailbox") === true ? true : false,
  isLoggedIn: storage.get("accessToken") ? true : false,
  errorMessage: null,
  mfa: 0,
  types: [],
  user: storage.get("user") || {},
  options: storage.get("options") || {},
  settings: storage.get("settings") || {},
  permissions: storage.get("permissions") || [],
  isAllImagesVisible: storage.get("isAllImagesVisible") || false,
  totalQuota: storage.get("totalQuota") || 0,
  usedQuota: storage.get("usedQuota") || 0,
  login: {
    step: "login",
    isLoginSideBarOpen: false,
    email: null,
    mfa_id: null,
    mfa_values: {},
    captcha_required: null,
    type: null,
    change_password: null,
    server_type: null,
    via_qr: null,
    loginResponse: null
  },
  sessionTimeout: {
    isOpen: false,
    email: null,
    errorMessage: null,
    isLoading: false
  },
  passwordWarning: null,
  redirectUrl: null
};

const reducer = produce((draft, action) => {
  switch (action.type) {
    case Actions.TRY_LOGIN:
      draft.isLoading = true;
      break;

    case Actions.LOGIN_SUCCESS:
      draft.isLoggedIn = true;
      draft.isLoading = false;
      draft.user = action.payload.user;
      draft.totalQuota = action.payload.totalQuota;
      draft.usedQuota = action.payload.usedQuota;
      draft.options = action.payload.options;
      draft.settings = action.payload.settings;
      draft.permissions = action.payload.permissions;
      draft.isLimited = action.payload.isLimited;
      draft.isNoMailbox = action.payload.isNoMailbox;
      draft.isPasswordRenewRequired = action.payload.isPasswordRenewRequired;
      draft.passwordWarning = action.payload.passwordWarning;
      draft.login = {
        step: "login",
        isLoginSideBarOpen: false,
        email: null,
        mfa_id: null,
        mfa_values: {},
        captcha_required: null,
        type: null,
        change_password: null,
        server_type: null,
        via_qr: null,
        loginResponse: null
      };
      draft.sessionTimeout = {
        isOpen: false,
        email: null,
        errorMessage: null,
        isLoading: false
      };
      draft.errorMessage = null;
      break;

    case Actions.SET_SESSION_TIMEOUT:
      draft.sessionTimeout = {
        ...draft.sessionTimeout,
        ...action.payload
      };
      break;

    case Actions.ADD_ACCOUNT:
      draft.accounts = {
        ...draft.accounts,
        ...action.payload
      };
      storage.set("accounts", draft.accounts);
      break;

    case Actions.REMOVE_ACCOUNT:
      delete draft.accounts[action.payload.email];
      storage.set("accounts", draft.accounts);
      break;

    case Actions.LOGIN_MFA:
      draft.errorMessage = null;
      draft.isLoading = false;
      draft.isLoggedIn = false;
      draft.mfa = action.payload.mfa;
      draft.types = action.payload.types;
      break;

    case Actions.SET_ALL_IMAGES_VISIBLE:
      draft.isAllImagesVisible = action.payload;
      break;

    case Actions.SET_LOGIN_BAR_BUTTON:
      draft.login.isLoginSideBarOpen = action.payload;
      break;

    case Actions.LOGIN_FAILED:
      if (action.payload.fromLimitedLogin) {
        draft.isLoading = false;
        draft.errorMessage = action.payload.errorMessage;
      } else if (window.location.pathname === "/timeout") {
        draft.isLoading = false;
        draft.errorMessage = action.payload.errorMessage;
        draft.login.step = action.payload?.step || "password";
      } else {
        draft.isLoading = false;
        draft.isLoggedIn = false;
        draft.errorMessage = action.payload.errorMessage;
        draft.totalQuota = 0;
        draft.usedQuota = 0;
        draft.user = {};
        draft.options = {};
        draft.settings = {};
        draft.login.step = action.payload?.step || "login";
      }
      break;

    case Actions.SET_IMAGE:
      draft.accounts[draft.user.email].image = action.payload.image;
      storage.set("accounts", draft.accounts);
      draft.user.image = action.payload.image;
      break;

    case Actions.SET_PASSWORD_RENEW:
      draft.isPasswordRenewRequired = action.payload;
      break;

    case Actions.SET_PASSWORD_WARNING:
      draft.passwordWarning = action.payload;
      break;

    case Actions.RESET_FAILED:
      draft.errorMessage = null;
      break;

    case Actions.LOGOUT:
      delete draft.accounts[draft.user.email];
      storage.set("accounts", draft.accounts);
      draft.isLoggedIn = false;
      draft.user = {};
      draft.totalQuota = 0;
      draft.usedQuota = 0;
      draft.redirectUrl = null;
      break;

    case Actions.UPDATE_SETTINGS:
      draft.settings = {
        ...draft.settings,
        ...action.payload
      };
      storage.set("settings", draft.settings);
      break;

    case Actions.SET_STEP_LOGIN:
      const isLoginSideBarOpen = draft.login.isLoginSideBarOpen;
      if (action.payload.step === "login") {
        draft.login = { ...initialState.login, isLoginSideBarOpen };
      }
      draft.isLoading = false;
      draft.errorMessage = null;
      draft.login = {
        ...draft.login,
        ...action.payload
      };
      break;

    case Actions.SET_CAPTCHA_REQUIRED:
      draft.login.captcha_required = action.payload.timestamp;
      break;

    case Actions.SET_REDIRECT_URL:
      draft.redirectUrl = action.payload.url;
      break;

    case Actions.SET_PERMISSIONS:
      draft.permissions = action.payload;
      break;

    default:
      return draft;
  }
}, initialState);

export default reducer;
